import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Shield, Loader2, ArrowLeft, Mail } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/api/admin/forgot-password`, { email });
    } catch { /* ignore */ }
    setSent(true);
    toast.success('Se o e-mail existir, um link será enviado');
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-slate-800/90 border-slate-700 backdrop-blur-sm">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4">
            <Shield className="h-8 w-8 text-white" />
          </div>
          <CardTitle className="text-xl text-white">Recuperar Senha Admin</CardTitle>
          <CardDescription className="text-slate-400">
            {sent ? 'Verifique sua caixa de entrada' : 'Informe o e-mail do administrador'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="text-center space-y-4" data-testid="admin-forgot-sent">
              <div className="w-14 h-14 rounded-full bg-blue-500/10 flex items-center justify-center mx-auto">
                <Mail className="h-7 w-7 text-blue-400" />
              </div>
              <p className="text-sm text-slate-300">Se o e-mail <strong className="text-white">{email}</strong> estiver cadastrado como administrador, você receberá um link de redefinição.</p>
              <p className="text-xs text-slate-500">O link expira em 1 hora.</p>
              <Link to="/admin-login">
                <Button variant="outline" className="border-slate-600 text-slate-300 hover:text-white" data-testid="admin-back-to-login">
                  <ArrowLeft className="h-4 w-4 mr-2" /> Voltar ao login
                </Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="admin-forgot-form">
              <div>
                <Label className="text-slate-300">E-mail do administrador</Label>
                <Input type="email" placeholder="admin@uclean.com" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-slate-700 border-slate-600 text-white placeholder:text-slate-500" data-testid="admin-forgot-email" />
              </div>
              <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700" disabled={loading} data-testid="admin-forgot-submit">
                {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : null}
                Enviar link de redefinição
              </Button>
              <div className="text-center">
                <Link to="/admin-login" className="text-sm text-blue-400 hover:underline">
                  <ArrowLeft className="h-3 w-3 inline mr-1" /> Voltar ao login
                </Link>
              </div>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
